module.exports = __webpack_public_path__ + "img/tips4_xj3.82aefbc5.jpg";